import React, { useContext } from 'react'

import SimpleLink from '../../../../components/Simple/SimpleLink'

import { Routes } from '../../../../configs/RouteConfig'
import UserContext from '../../../../helper/userContext'

const ReferenceNumberRenderer = (props) => {
  const { appointment } = props.data

  const { currentLanguage } = useContext(UserContext)

  return (
    <SimpleLink
      to={
        '/' +
        currentLanguage +
        Routes.usageUnit +
        '/' +
        appointment?.usageUnit?.tableId
      }
      style={{ fontSize: 'inherit' }}
    >
      {appointment?.usageUnit?.referenceNumber}
    </SimpleLink>
  )
}

export default ReferenceNumberRenderer
